import styled from 'styled-components';

export const Tiles = styled.div`
  display: flex;
  > * {
    margin-right: 1.25vw;
  }
`;
